import { Message } from "element-ui";
import "element-ui/lib/theme-chalk/message.css";
export default [
  [
    "copy",
    {  
        // 当被绑定的元素插入到 DOM 中时  
        bind(el, binding, vnode) {  
          // 监听点击事件  
          el.onclick = function(e) {  
            // 阻止默认行为（如果需要）  
            e.preventDefault();  
        
            // 获取要复制的文本  
            const textToCopy = binding.value;  
        
            // 创建一个临时的 textarea 元素  
            const textarea = document.createElement('textarea');  
            // 设置 textarea 为不可见  
            textarea.style.position = 'fixed'; // 可以避免在页面上滚动  
            textarea.style.opacity = 0;  
            // 设置 textarea 的值  
            textarea.value = textToCopy;  
            // 将 textarea 添加到 body 中  
            document.body.appendChild(textarea);  
            // 选中 textarea 中的文本  
            textarea.select();  
              
            try {  
              // 尝试复制文本到剪贴板  
              document.execCommand('copy');  
              // 可以选择在这里添加一些提示信息，比如使用 ElementUI 的 Message 组件  
              // 注意：如果你使用了 Vuex 或其他状态管理，你可能需要另一种方式来访问 Message 组件  
              // 这里为了简单起见，我们直接使用 alert  
              Message.success('已复制到剪贴板');
            } catch (err) {  
              // 复制失败  
              console.error('复制失败:', err);  
            }  
        
            // 移除 textarea  
            document.body.removeChild(textarea);  
          };  
        }  
      }
  ],
];
